if (!customElements.get('omnibus-price-history')) {
  customElements.define('omnibus-price-history', class OmnibusPriceHistory extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.omnibus-price-history');
      if (!this.trigger) return;

      const popup = this.trigger.querySelector('.omnibus-price-history-popup');
      this.trigger.setAttribute('tabindex', '0');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.dataset.label) this.trigger.setAttribute('aria-label', this.dataset.label);
      if (popup && popup.id) {
        this.trigger.setAttribute('aria-controls', popup.id);
        this.trigger.setAttribute('aria-describedby', popup.id);
      }

      this.positionArrow = this.positionArrow.bind(this);
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onTriggerKeydown = this.onTriggerKeydown.bind(this);
      this.onTriggerMouseLeave = this.onTriggerMouseLeave.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);

      this.trigger.addEventListener('mouseenter', this.positionArrow);
      this.trigger.addEventListener('focus', this.positionArrow);
      this.trigger.addEventListener('click', this.onTriggerClick);
      this.trigger.addEventListener('keydown', this.onTriggerKeydown);
      this.trigger.addEventListener('mouseleave', this.onTriggerMouseLeave);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onDocumentKeydown);
    }

    disconnectedCallback() {
      if (!this.trigger) return;

      this.trigger.removeEventListener('mouseenter', this.positionArrow);
      this.trigger.removeEventListener('focus', this.positionArrow);
      this.trigger.removeEventListener('click', this.onTriggerClick);
      this.trigger.removeEventListener('keydown', this.onTriggerKeydown);
      this.trigger.removeEventListener('mouseleave', this.onTriggerMouseLeave);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onDocumentKeydown);
    }

    positionArrow() {
      const row = this.closest('.product-price-row');
      if (!row) return;

      const triggerRect = this.trigger.getBoundingClientRect();
      const arrowLeft = triggerRect.left + triggerRect.width / 2 - row.getBoundingClientRect().left;
      this.style.setProperty('--omnibus-arrow-left', `${arrowLeft}px`);
    }

    isOpen() {
      return this.trigger.classList.contains('is-open');
    }

    setOpen(open) {
      if (open) {
        this.positionArrow();
        this.trigger.classList.remove('is-dismissed');
      }
      this.trigger.classList.toggle('is-open', open);
      this.trigger.setAttribute('aria-expanded', String(open));
    }

    onTriggerClick(event) {
      if (event.target.closest('.omnibus-price-history-popup')) return;
      this.setOpen(!this.isOpen());
    }

    onTriggerKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.setOpen(!this.isOpen());
    }

    onTriggerMouseLeave() {
      this.trigger.classList.remove('is-dismissed');
    }

    onDocumentKeydown(event) {
      if (event.key !== 'Escape') return;
      this.setOpen(false);
      if (this.trigger.matches(':hover')) this.trigger.classList.add('is-dismissed');
    }

    onFocusOut(event) {
      if (!this.contains(event.relatedTarget)) this.setOpen(false);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.setOpen(false);
    }
  });
}
